/*
 * Bundle entry point. esbuild compiles this to dist/js/app.js.
 *
 * Every component is a no-op unless its markup is on the page, so this list
 * can stay as-is for the life of the project — delete an import only when you
 * have removed the component from the template for good.
 */
import $ from "./lib/jquery.js";

import initForms from "./components/form.js";
import initFormSlider from "./components/form-slider.js";
import initGalleryFader from "./components/gallery-fader.js";
import initGoogleMap from "./components/google-map.js";
import initInteractiveMap from "./components/interactive-map.js";
import initRecaptcha from "./components/recaptcha.js";

import { alignContent, backToTop, baselineAlign, equalHeights, scrollToAnchor } from "./lib/dom.js";

/*
 * Layout helpers that page-level inline scripts still call by name.
 * Reach for CSS grid or flexbox first — these are for the awkward cases.
 */
Object.assign(window, { alignContent, backToTop, baselineAlign, equalHeights, scrollToAnchor });

function init() {
  initRecaptcha();
  initForms();
  initFormSlider();
  initGalleryFader();
  initInteractiveMap();
  initGoogleMap();

  /*
   * sliders() before animation(), deliberately. slick's `infinite` mode
   * clones slides to fill the loop, and those clones are copies of markup
   * that carries `data-aos` (component-text-block.php puts it on its
   * wrapper). AOS collects [data-aos] once, inside AOS.init(), so anything
   * cloned after that is never in its store, never gets `.aos-animate`, and
   * stays at the opacity: 0 aos.css sets on it — the image renders and the
   * text block is invisible. Building the sliders first means the clones
   * already exist when AOS goes looking.
   */
  sliders();
  animation();
  menu();

  document.querySelectorAll(".scroller").forEach((el) => {
    el.addEventListener("click", () => scrollToAnchor(el.dataset.scrollpos));
  });
}

/*
 * Wait for ready, never run on the spot. header.php loads this bundle with
 * `defer`, so by the time it executes readyState is already "interactive" —
 * running immediately would beat the deferred plugin scripts that come after
 * it (slick, fancybox) and leave $.fn.slick undefined in sliders() below.
 * Deferred scripts all run before DOMContentLoaded, so waiting for it is what
 * makes the ordering in header.php mean what it looks like it means.
 */
$(init);

function animation(){


    // Animate on scroll init
    AOS.init({
      duration: 1000, // values from 0 to 3000, with step 50ms
      once: true, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      // disable: 'mobile',
    });

    /*
     * refreshHard, not refresh: refresh() only recalculates offsets against
     * the elements AOS already knows about, so it cannot pick up markup that
     * appeared after init (slick clones, anything injected later). This is
     * the belt to the ordering above's braces.
     */
    setTimeout(function() {
        AOS.refreshHard();
    }, 500);
}

$(window).on('resize orientationchange', function() {
    $('.slider-basic').slick('resize');
    $('.slider-2-col').slick('resize');
    $('.slider-3-col').slick('resize');
    $('.carousel-strip').slick('resize');

    /*
     * Last again, and for the same reason: .slider-3-col's 991 breakpoint
     * takes it from three slides to one, which triples the width of the
     * .slider-fade nested in it. The nested slider only picks that up if it
     * re-measures after its container has.
     */
    $('.slider-fade').slick('resize');
});

function sliders(){
    if($('.slider-basic').length){

        $('.slider-basic').slick({
            autoplay: true,
            arrows: true,
            dots: true,
        });
    }
    if($('.slider-2-col').length){
        $('.slider-2-col').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 2,
            arrows: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    if($('.slider-3-col').length){
        $('.slider-3-col').slick({
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 3,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    if($('.carousel-strip').length){
        /*
         * The strip is a marquee on desktop, not a slideshow: autoplaySpeed 0
         * removes the dwell between slides, so slick starts the next
         * transition the moment the last one ends, and a linear cssEase over a
         * long `speed` turns that chain into one unbroken glide. Both are
         * needed — a linear ease alone still stops dead between slides, and
         * autoplaySpeed 0 with the default easing visibly accelerates into
         * every image.
         *
         * pauseOnHover has to be off for the same reason. It defaults to true,
         * which reads fine on a 3s slideshow but halts a marquee mid-travel
         * and leaves the strip parked between two slides.
         *
         * mobileFirst inverts `responsive`: the block below applies from 992px
         * up, and the settings out here are the mobile ones — one slide at a
         * time, cross-fading, the same as .slider-fade above.
         *
         * Which is why the desktop block spells out `fade: false`. slick
         * merges a breakpoint over the *original* options rather than over
         * defaults, so every value set out here leaks upward unless the
         * breakpoint overrides it — and fade with slidesToShow 4 stacks all
         * four images on top of each other.
         */
        /*
         * rtl is what reverses the marquee, but the option alone renders the
         * strip blank: slick.css only floats slides right under [dir='rtl'],
         * so with rtl:true and no dir the JS positions the track as though the
         * slides were laid out in reverse while they are still laid out
         * forwards, and every image ends up outside the visible window.
         *
         * The dir attribute cannot just live in the markup either — it is not
         * responsive, and on mobile it floats the fade slides right while
         * options.rtl is false, which blanks the strip at phone widths.
         *
         * So dir follows slick's own options.rtl, set from the events slick
         * fires when it builds and when it crosses a breakpoint. Nothing here
         * repeats the 992 above, so the CSS and the config cannot drift apart.
         * setPosition re-measures afterwards, since changing the float has
         * moved every slide slick had already measured.
         */
        $('.carousel-strip').on('init breakpoint', function (e, slick) {
            $(this).attr('dir', slick.options.rtl ? 'rtl' : 'ltr');
            slick.setPosition();
        }).slick({
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        rtl: true,
                        fade: false,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 0,
                        speed: 3000,
                        cssEase: 'linear',
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        arrows: false,
                        dots: false
                    }
                }
            ]
        });
    }

    /*
     * .slider-fade goes LAST, after every slider that might contain one.
     *
     * A fade slider sizes itself from its container: setDimensions takes
     * slideWidth from .slick-list's width and hard-sets the track to
     * slideWidth x slide count, while setFade parks slide N at
     * left: -(slideWidth * N). content/inc.precinct.php nests one inside
     * .slider-3-col, so until that outer slider is built its slides are
     * still full-width block elements — a .slider-fade initialised first
     * measures the whole ~1489px row rather than the ~483px slide.
     *
     * The original recovers from that on its own: slick binds window `load`
     * to setPosition, which re-measures once the outer slider is laid out.
     * Its *clone* does not. .slider-3-col is infinite, so it copies the
     * carmine slide with .clone(true) during its own init — and a clone made
     * from already-initialised markup is a dead copy, carrying the stale
     * 2978px track and a jQuery data key pointing at the original's
     * instance, with nothing left to re-measure it. That clone is the one
     * that showed a 3000px track, which is why the fault came and went as
     * the outer carousel looped onto the cloned slide.
     *
     * Initialising here, after the clones exist and while they are still
     * plain markup, gives every copy a correctly-measured instance of its
     * own — verified: both nested tracks now build at 966px.
     */
    if($('.slider-fade').length){

        $('.slider-fade').slick({
            autoplay: true,
            autoplaySpeed: 3000,

            speed: 1000, // transition speed
            
            fade: true,

            // disable all touch/swipe effects.
            // swipe: false,
            // touchMove: false,
            // draggable: false,

            arrows: false,
            dots: false,
        });
    }

    if($(".slider-prev").length && $(".slider-next").length){
        $(".slider-prev").click(function (e) {
            e.preventDefault();
            firstLevel($('#' + $(this).attr('data-sliderControl')), '.slick-slider').slick("slickPrev");
        });

        $(".slider-next").click(function (e) {
            e.preventDefault();
            firstLevel($('#' + $(this).attr('data-sliderControl')), '.slick-slider').slick("slickNext");
        });
    }
}


/*
 * A slide of an outer slider can hold a slider of its own — .slider-fade
 * inside .slider-3-col in content/inc.precinct.php. .find() reaches into
 * those as well, so the arrows were stepping the nested slider alongside the
 * one they belong to.
 *
 * So keep only the matches with no .slick-slider between them and the
 * container: the first level down. parentsUntil() stops *before* $container,
 * so passing a slider itself as the container works too — .slick-list and
 * .slick-track are all that sit between it and its own slides.
 */
function firstLevel($container, selector){
    return $container.find(selector).filter(function(){
        return $(this).parentsUntil($container, '.slick-slider').length === 0;
    });
}

function menu(){
    $('.toggle-menu').click(function(){
        $('body').toggleClass('menu-active');
        $('body').removeClass('enquire-active');

        $('.hamburger.toggle-menu').toggleClass('is-active');
        if( ! $('body').hasClass('enquire-active') ) {
          $('.hbspt-form').find('input[name="apartment"]').val("");
        }
    });
    $('.toggle-enquire').click(function(){
        $('body').toggleClass('enquire-active');
        $('body').removeClass('menu-active');
        $('.hamburger.toggle-menu').removeClass('is-active');


        if($(this).attr('data-code') !== undefined){
            var code = $(this).attr('data-code');
            // console.log(code);
            $('.hbspt-form').find('input[name="apartment"]').val(code);
        }

        if(! $('body').hasClass('enquire-active') ) {
          $('.hbspt-form').find('input[name="apartment"]').val("");
        }

    });
}